export const sortingOptions = {
  RELEVANCY: 'relevancy',
  MODIFY_DATE: 'modifyDate',
};
